import { useSelector } from 'react-redux';

import CourseRow from './CourseRow';
import SectionSelector from './SectionSelector';

import styles from './CourseInfoSection.module.css';
import { useContext, useMemo } from 'react';
import ReactTimetableContext from '../context/ReactTimetableContext';

const CourseInfoSection = () => {
    const registeredCourses = useSelector(state => (state.app.registeredCourses));

    const { tbaBoxes } = useContext(ReactTimetableContext);
    const tbaCourses = useMemo(() => (
        [...new Set(tbaBoxes.map(box => `${box.code} ${box.section}`))].join(', ')
    ), [tbaBoxes]);

    return (
        <div className={styles.courseInfoSection}>
            <div className={styles.tbaCourses}>
                {`Unscheduled or TBA sections: `}
                <span>{tbaCourses || 'None'}</span>
            </div>
            <div className={styles.sectionSelectorsContainer}>
                {registeredCourses && registeredCourses.length > 0 && registeredCourses.map(courseCode => (
                    <SectionSelector
                        key={`selector-${courseCode}`}
                        courseCode={courseCode}
                    />
                ))}
            </div>
            <div className={styles.courseListContainer}>
                <table className={styles.timetableControls}>
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Title</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {registeredCourses.length ? (
                            registeredCourses.map(courseCode => (
                                <CourseRow
                                    key={courseCode}
                                    courseCode={courseCode}
                                />
                            ))
                        ) : (
                            <tr className={styles.none}>
                                <td colSpan={3}>No courses added.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default CourseInfoSection;
